module.exports = __webpack_public_path__ + "media/components/assets/upcycling_03-d00d24281d7aff395b12c3bbe3e0c0c3.jpg";